<template>
  <div style="position:relative;">
    <div class="rasgado rasgado-top"></div>

    <section class="itinerario-poster" ref="sectionRef">

      <h2 class="poster-title">Itinerario</h2>

      <div
        v-for="(evento, index) in eventos"
        :key="evento.nombre"
        class="poster-item"
        :ref="el => itemRefs[index] = el"
      >
        <img :src="evento.icono" class="poster-icon" />
        <p class="poster-text">
          <span class="evento-nombre">{{ evento.nombre }}</span>
          <span class="evento-hora">{{ evento.hora }}</span>
          <span v-if="evento.nota" class="evento-nota">{{ evento.nota }}</span>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'ItinerarioPoster',
  setup() {
    const eventos = [
      {
        nombre: 'Ceremonia Religiosa',
        hora: '2:00 PM',
        icono: require('@/assets/og.png')
      },
       {
        nombre: ' Comida',
        hora: '3:00 - 6:30 PM',
        icono: require('@/assets/cen.avif')
      },
      {
        nombre: 'Vals y Coronación ',
        hora: '6:30 PM',
        icono: require('@/assets/valss.png')
      },
     
      {
        nombre: 'Baile',
        hora: '9:00 PM - en adelante',
        nota: 'A disfrutar la fiesta!',
        icono: require('@/assets/fiesta.avif')
      }
    ]

    const itemRefs = ref([])
    const sectionRef = ref(null)

    onMounted(() => {
      itemRefs.value.forEach((el, index) => {
        if (!el) return

        const icon = el.querySelector('.poster-icon')
        const text = el.querySelector('.poster-text')

        gsap.set([icon, text], { opacity: 0 })

        const animations = [
          { y: 40 },
          { x: -40 },
          { scale: 0.85 },
          { x: 40 },
          { y: -40 },
          { scale: 0.9 },
          { x: -30 },
          { y: 30 }
        ]

        const fromVars = animations[index % animations.length]

        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return

            gsap.fromTo(
              icon,
              { ...fromVars, opacity: 0 },
              { opacity: 1, x: 0, y: 0, scale: 1, duration: 1, ease: 'power3.out' }
            )

            gsap.fromTo(
              text,
              { y: 20, opacity: 0 },
              { y: 0, opacity: 1, duration: 1, delay: 0.2, ease: 'power2.out' }
            )

            obs.unobserve(entry.target)
          })
        }, { threshold: 0.3 })

        observer.observe(el)
      })
    })

    return { eventos, itemRefs, sectionRef }
  }
}
</script>

<style scoped>
.itinerario-poster {  overflow: visible;

   background:
    linear-gradient(
      rgba(231, 187, 187, 0.541),
      rgba(236, 192, 191, 0.705)
    ),
    url('@/assets/fn.avif') center center / cover no-repeat;padding: 60px 20px 80px;
  text-align: center;
  position: relative; /* 🔥 necesario para que el rasgado se posicione aquí */
}

.poster-title {
  font-family: 'Playfair Display', serif;
  font-size: 44px;
  letter-spacing: 2px;
  color: #514e4e;
  margin-bottom: 50px;
}

.poster-item {
  margin-bottom: 42px;
}

.poster-icon {
  width: 114px;
  height: auto;
  margin-bottom: 12px;
}

.poster-text {
  font-family: 'Playfair Display', serif;
  color: #282727;
  line-height: 1.4;
}

.evento-nombre {
  display: block;
  font-size: 22px;
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;  overflow: visible;

  background:
    linear-gradient(
      rgba(214, 172, 172, 0.669),
      rgba(208, 152, 180, 0.352)
    ),
    url('@/assets/fn.avif') center center / cover no-repeat;   z-index: 5;
  pointer-events: none;
}


.rasgado-top {  
    background:
    linear-gradient(
      rgba(231, 187, 187, 0.541),
      rgba(236, 192, 191, 0.705)
    ),
    url('@/assets/fn.avif') center center / cover no-repeat;
  top: 0;
  clip-path: polygon(0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%);
}

.rasgado-bottom {  overflow: visible;

   background:
    linear-gradient(
      rgba(231, 187, 187, 0.541),
      rgba(236, 192, 191, 0.705)
    ),
    url('@/assets/fn.avif') center center / cover no-repeat;
  clip-path: polygon(0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%);
}

.evento-hora {
  display: block;
  font-size: 20px;
  font-style: italic;
  margin-top: 4px;
}
</style>
